import { render, staticRenderFns } from "./EditSupplyRulePage.vue?vue&type=template&id=30aadd01"
import script from "./EditSupplyRulePage.vue?vue&type=script&lang=js"
export * from "./EditSupplyRulePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports